import React from 'react';
import DynamicPage from '../dynamic-page/index';
import '../../assets/css/questionnaire-item.less';

// 基础组件对照
const questionTypeToComponent = {
    MULTIPLE_CHOICE: 'dy-checkbox',
    SINGLE_CHOICE: 'dy-radio',
    FILL_IN_BLANK: 'dy-textarea',
    PHOTO_UPLOAD: 'dy-file-upload',
};
// 自定义组件对照
const nameToComponent = {
    省市区: 'dy-city',
    入学年份: 'dy-datepicker',
    毕业时间: 'dy-datepicker',
    学校: 'dy-school',
    学院: 'dy-school',
    专业: 'dy-school',
    职业状态: 'dy-picker',
    证件类型: 'dy-picker',
    学历: 'dy-picker',
    手机号码: 'dy-input',
    微信号码: 'dy-input',
    邮箱: 'dy-input',
    姓名: 'dy-input',
    国家: 'dy-input',
    证件编码: 'dy-input',
    国际号: 'dy-international-number',
    研究生专业: 'dy-graduate',
    省份: 'dy-province'
    
};
/**
 * 通过问卷类型和问题名获取对应组件
 * @param qtype 问题类型
 * @param bizTypeName 问题名
 */
export const getComponentByQTypeAndName = (qtype, bizTypeName) => {
    // 如果有自定义组件返回自定义，无则返回基础组件
    return nameToComponent[bizTypeName] || questionTypeToComponent[qtype];
};

export const getComponentType = bizTypeName => {
    if (bizTypeName === '入学年份' || bizTypeName === '毕业时间') {
        return {
            type: 'year',
        };
    }
    if (bizTypeName === '手机号码') {
        return {
            type: 'tel',
            maxLength: 11,
        };
    }
    if (bizTypeName === '微信号码') {
        return {
            type: 'text',
            maxLength: 20,
        };
    }
    if (bizTypeName === '邮箱') {
        return {
            type: 'email',
            maxLength: 30,
        };
    }

    return {};
};

export interface Question {
    questionMutual: any;
    question: string;
    order: number;
    name: string;
    bizTypeName: string;
    content: string;
    questionType: string;
    selectItemList?: any[];
}

export type QuestionnaireItemProps = {
    name?: string;
    question: Question;
    required?: boolean;
    disabled?: boolean;
    defaultAnswer?: any;
    error?: string;
    onChange?: (value) => void;
} & Props;

class QuestionnaireItem extends React.Component<QuestionnaireItemProps, State> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { name, value, defaultAnswer, question, onChange, required, disabled, error } = this.props;
        const cpname = getComponentByQTypeAndName(question.questionType, question.bizTypeName);
        const otherProps = getComponentType(question.bizTypeName);
        return (
            <div
                className={`questionnaire-item ${required ? 'required' : ''} ${
                    question.questionType !== 'PHOTO_UPLOAD' && disabled ? 'disabled' : ''
                }`}
            >
                <div className="questionnaire-item-q">
                    {question.order}.{question.content}
                </div>
                <div className="questionnaire-item-a">
                    {
                        // 动态组件渲染
                        DynamicPage.ComponentRender({
                            // 组件名--必须是已经注册的组件
                            name: cpname,
                            props: {
                                name,
                                value,
                                options: question.selectItemList,
                                selectType: question.questionMutual,
                                ...otherProps,
                                // 院校选择单独处理默认值
                                ...(cpname == 'dy-school' ? { defaultAnswer: value || defaultAnswer } : {}),
                                onChange: onChange,
                                disabled: disabled,
                            },
                        })
                    }
                </div>
                {error && (
                    <div className="questionnaire-item-e">
                        <i className="iconfont iconpoint"></i>
                        {error}
                    </div>
                )}
            </div>
        );
    }
}

export default QuestionnaireItem;
